import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PPMU_AVERAGE_AMOUNT_EXPERIMENT = defineFcm('ppmu_average_amount_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				averageAmount: { type: 'number' },
				countryCode: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PPMU',
		description: 'This FCM config controls the PPMU average amount experiment',
		import: false,
		template: {
			experimentName: '',
			averageAmount: 12,
			countryCode: 'US',
		},
	});
